export const contactsData = {
  email: "dev.vidurt@gmail.com",
  address: "Calgary, Alberta, Canada",
  headline: "Let's talk.",
  subtext:
    "A question, a project, or just to connect — reach me below.",

  sheetAPI: "https://contact-a1a48-default-rtdb.firebaseio.com/contact",
};
